import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, Location, LocationWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateLocation(): UseMutationResult<
  AxiosResponse<Location>,
  AxiosError<ErrorMessage>,
  LocationWrite
> {
  const queryClient = useQueryClient();

  const createLocation = useCallback((location: LocationWrite): Promise<AxiosResponse<Location>> => {
    return client.post('locations/', location);
  }, []);

  return useMutation(createLocation, {
    onSuccess: () => {
      queryClient.invalidateQueries('locations');
    },
  });
}
